import React from 'react'
import { Link } from 'react-router-dom'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useFetch, useDeleteStorageIntegration, useEnableStorageIntegration, useDisableStorageIntegration } from '../../../../hooks/admin/settings/storage'

import { Popconfirm, Space, Button, Alert, Avatar, List, PageHeader } from 'antd'
import Loader from '../../../../components/loader'

import { LAYOUT_ADMIN_STORAGE_FORM } from '../../navigation'

const IntegrationIcon = require('../../../../assets/icons/integration-storage.png')

const boxData = {
  storage: 'Box',
  title: 'Box self-hosted storage',
  description: 'Box Integration is designed to store your data in Box service using the Box API.'
}

const s3Data = {
  storage: 'S3',
  title: 'S3 self-hosted storage',
  description: 'S3 Integration is designed to store your data in any S3 compatible storage.'
}

const radixData = {
  storage: 'Radix',
  title: 'Radix-hosted storage',
  description: 'Radix Integration is designed to store your data in our storage service.'
}

const CustomItem = (props) => {
  const { data, enableStorageIntegration, deleteStorageIntegration, disableStorageIntegration } = props
  return (
    <List.Item
      actions={[
        <Space key='actions'>
          {enableStorageIntegration && (
            <Popconfirm
              title='Are you sure?'
              onConfirm={() => enableStorageIntegration(data.storage)}
              okText='Yes'
              cancelText='No'
            >
              <Button type='link' size='small'>
                Enable
              </Button>
            </Popconfirm>
          )}
          {deleteStorageIntegration && (
            <Popconfirm
              title='Are you sure?'
              onConfirm={() => deleteStorageIntegration(data.storage)}
              okText='Yes'
              cancelText='No'
            >
              <Button type='link' size='small'>
                Remove
              </Button>
            </Popconfirm>
          )}

          {disableStorageIntegration && (
            <Popconfirm
              title='Are you really sure?'
              onConfirm={disableStorageIntegration}
              okText='Yes, I am sure'
              cancelText='No'
              okType='danger'
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              description="Some functionally won't work properly without storage"
            >
              <Button type='link' size='small'>
                Disable
              </Button>
            </Popconfirm>
          )}
        </Space>
      ]}
    >
      <List.Item.Meta
        avatar={<Avatar src={IntegrationIcon} shape='square' />}
        title={<b>{data.title}</b>}
        description={data?.description}
      />
    </List.Item>
  )
}

const App = () => {
  const { data, isLoading, isError } = useFetch()
  const { mutate: enableStorageIntegration, isLoading: isEnableLoading } = useEnableStorageIntegration()
  const { mutate: disableStorageIntegration, isLoading: isDisableLoading } = useDisableStorageIntegration()
  const { mutate: deleteStorageIntegration, isLoading: isRemoveLoading } = useDeleteStorageIntegration()

  const actionLoading = isEnableLoading || isDisableLoading || isRemoveLoading

  if (isLoading || actionLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const { entity } = data

  const onEnableStorageIntegration = () => {
    if (entity?.storage) {
      return false
    }

    return enableStorageIntegration
  }

  const enabledData = () => {
    if (entity?.storage === 'Box') {
      return boxData
    }

    if (entity?.storage === 'S3') {
      return s3Data
    }

    if (entity?.storage === 'Radix') {
      return radixData
    }

    return { title: 'Unknown', storage: '', description: '' }
  }

  return (
    <>
      {!entity.storage && (
        <Alert
          message='No storage is set.'
          description="Some functionally won't work properly without storage"
          type='warning'
          showIcon
          closable
        />
      )}

      {entity.storage && (
        <PageHeader title='Storage Enabled'>
          <CustomItem data={enabledData()} disableStorageIntegration={disableStorageIntegration} />
        </PageHeader>
      )}

      <br />

      <PageHeader title='Storage Options' extra={[<Link key='add' to={LAYOUT_ADMIN_STORAGE_FORM}>Add integration</Link>]}>
        <List itemLayout='horizontal'>
          <CustomItem data={radixData} enableStorageIntegration={onEnableStorageIntegration()} />
          {entity?.s3_configured && (
            <CustomItem
              data={s3Data}
              enableStorageIntegration={onEnableStorageIntegration()}
              deleteStorageIntegration={deleteStorageIntegration}
            />
          )}
          {entity?.box_configured && (
            <CustomItem
              data={boxData}
              enableStorageIntegration={onEnableStorageIntegration()}
              deleteStorageIntegration={deleteStorageIntegration}
            />
          )}
        </List>
      </PageHeader>
    </>
  )
}

export default App
